import React from 'react';

import Icon from '../Icon/Icon';

const HomeIcon = (props) => {
    return (
        <Icon width='24' height='24' fill='none' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 2C12.4752 2 12.9493 2.16149 13.344 2.48446L19.1622 7.24782C19.4231 7.46152 19.6341 7.73463 19.7793 8.04645C19.9245 8.35827 19.9999 8.70062 20 9.04753V19.7148C20 20.3455 19.7556 20.9173 19.361 21.3307C18.9663 21.7441 18.4204 22 17.8182 22H6.18182C5.89524 22.0004 5.61142 21.9415 5.34666 21.8266C5.08189 21.7117 4.84141 21.5432 4.63903 21.3307C4.43613 21.1187 4.27522 20.8668 4.16556 20.5895C4.05589 20.3122 3.99963 20.015 4 19.7148V9.04753C4 8.34471 4.30934 7.68048 4.83782 7.24782L10.656 2.48446C11.0397 2.1701 11.5129 1.99952 12 2V2Z'
                stroke='#393E44'
                strokeWidth='1.5'
            />
        </Icon>
    );
};

export default HomeIcon;
